const STORAGE_KEY = "ar_ads_attribution";
const ATTRIBUTION_WINDOW_DAYS = 90;

export function getAttribution() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const record = JSON.parse(raw);
    if (record.capturedAt) {
      const age = Date.now() - new Date(record.capturedAt).getTime();
      if (age > ATTRIBUTION_WINDOW_DAYS * 24 * 60 * 60 * 1000) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
    }
    return record;
  } catch {
    return null;
  }
}

export function captureAttribution() {
  try {
    const params = new URLSearchParams(window.location.search);
    const gclid = params.get("gclid");
    const gbraid = params.get("gbraid");
    const wbraid = params.get("wbraid");
    if (!gclid && !gbraid && !wbraid) return getAttribution();

    const existing = getAttribution() || {};
    const record = {
      gclid: gclid || existing.gclid || null,
      gbraid: gbraid || existing.gbraid || null,
      wbraid: wbraid || existing.wbraid || null,
      capturedAt: new Date().toISOString(),
      landingPage: window.location.href.split("?")[0],
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
    return record;
  } catch {
    return null;
  }
}
